var ko = require('knockout');

var Timestatus = function(params) {
  var self = this;
  self.title = params.title;
  self.texts = params.texts;
  self.hoursCompleted = ko
    .observable(0)
    .subscribeTo('totalHoursDoneWithUnstructured', true);
  self.hoursTotal = ko.observable(80).subscribeTo('hoursRequirement', true);
  self.currentStartYear = ko
    .observable(0)
    .subscribeTo('currentStartYear', true);
  self.currentEndYear = ko.observable(0).subscribeTo('currentEndYear', true);
  self.isExpanded = ko.observable(true);
  self.description = ko.observable();
  self.requirementHoursFromMainCategories = ko.observable(0)
    .subscribeTo('requirementHoursFromMainCategories', true);
  self.hoursFromMainCategories = ko.observable(0)
    .subscribeTo('hoursFromMainCategories', true);
  self.requirementHoursFromMainCategoriesCovered = ko.observable(false)
    .subscribeTo('requirementHoursFromMainCategoriesCovered', true);
  self.requirementHoursPerMainCategoryCovered = ko.observable(false)
    .subscribeTo('requirementHoursPerMainCategoryCovered', true);
  self.requirementHoursFromMainCategoriesText = ko.observable();
  self.requirementHoursPerMainCategoryText = ko.observable();
  self.color = ko.observable();
  self.toggleExpanded = function() {
    self.isExpanded(!this.isExpanded());
  };
  this.isLoading = ko.observable(true).subscribeTo('periodYearsLoading', true);

  ko.postbox.subscribe(
    'periodYearsLoading',
    function(isLoading) {
      if (!isLoading) this.categorizeProgress();
    }.bind(this)
  );
};

Timestatus.prototype.categorizeProgress = function() {
  var userProgress = this.hoursCompleted(),
    totalRequiredHours = this.hoursTotal(),
    message = '',
    color = '',
    endYear = this.currentEndYear(),
    daysInYear = 365,
    regnskapsforer = totalRequiredHours === 80,
    remainingDays = getRemainingDaysForCurrentYear(this.currentEndYear());
  var startingPointsRegnskap = [70, 55, 35, 20];
  var startingPointsRevisor = [105, 85, 60, 40];
  function polynomialInterpolation(
    userProgress,
    totalRequiredHours,
    startingPoint,
    remainingDays,
    degree
  ) {
    return (
      startingPoint +
      ((totalRequiredHours - startingPoint) / Math.pow(remainingDays, degree)) *
        Math.pow(remainingDays - userProgress, degree)
    );
  }
  function calculateY(userProgress, remainingDays, degree, index) {
    var startingPoint = regnskapsforer
      ? startingPointsRegnskap[index]
      : startingPointsRevisor[index];

    return polynomialInterpolation(
      userProgress,
      totalRequiredHours,
      startingPoint,
      remainingDays,
      degree
    );
  }
  function getRemainingDaysForCurrentYear(endYear) {
    var currentDate = new Date();
    var endDate = new Date(endYear, 11, 31);
    var timeDiff = endDate.getTime() - currentDate.getTime();
    var remainingDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return remainingDays;
  }
  var y_values = [
    calculateY(userProgress, remainingDays, 2, 0),
    calculateY(userProgress, remainingDays, 2, 1),
    calculateY(userProgress, remainingDays, 3, 2),
    calculateY(userProgress, remainingDays, 6, 3)
  ];

  if (userProgress >= totalRequiredHours + 20) {
    message = this.texts.extraEffortStatusDescription;
    color = '#02C065';
  } else if (userProgress >= totalRequiredHours) {
    message = this.texts.approvedStatusDescription;
    color = '#02C065';
  } else if (remainingDays > daysInYear) {
    message = this.texts.deadlineStatusDescription;
    color = '#FECB2F';
  } else if (userProgress >= y_values[0]) {
    message = this.texts.aheadStatusDescription;
    color = '#FECB2F';
  } else if (userProgress >= y_values[1]) {
    message = this.texts.wellOnWayStatusDescription;
    color = '#FECB2F';
  } else if (userProgress >= y_values[2]) {
    message = this.texts.missingStatusDescription;
    color = '#FECB2F';
  } else if (userProgress >= y_values[3]) {
    message = this.texts.warningStatusDescription;
    color = '#DF3232';
  } else {
    message = this.texts.criticalStatusDescription;
    color = '#DF3232';
  }

  if (color === '#02C065' && !(this.requirementHoursFromMainCategoriesCovered() && this.requirementHoursPerMainCategoryCovered())) {
    color = '#FECB2F';
    message = this.texts.partiallyApprovedStatusDescription;
  }

  this.description(
    message
      .replace('{endYear}', endYear)
      .replace('{totalRequiredHours}', totalRequiredHours)
      .replace('{userProgress}', userProgress)
      .replace('{remainingDays}', remainingDays)
  );

  this.color(color);

  this.requirementHoursFromMainCategoriesText(
    this.requirementHoursFromMainCategoriesCovered()
      ? this.texts.requirementHoursFromMainCategoriesCoveredText
      : this.texts.requirementHoursFromMainCategoriesNotCoveredText.replace("{hours}", this.hoursFromMainCategories()).replace("{requirement}", this.requirementHoursFromMainCategories()));

  this.requirementHoursPerMainCategoryText(
    this.requirementHoursPerMainCategoryCovered()
      ? this.texts.requirementHoursPerMainCategoryCoveredText
      : this.texts.requirementHoursPerMainCategoryNotCoveredText);
};

module.exports = Timestatus;
